import { useTranslation } from 'react-i18next';

export type RhythmDisplayProps = {
  onSiteSlotsWithoutAssistant: number | null | undefined;
  remoteSlotsWithoutAssistant: number | null | undefined;
  onSiteSlotsWithAssistant: number | null | undefined;
  remoteSlotsWithAssistant: number | null | undefined;
  rhythmNote?: string | null;
};

/**
 * Read-only display component for structured rhythm fields
 * Shows SA (Sans Assistant) and AA (Avec Assistant) with on-site (P) and remote (V) slots
 */
export function RhythmDisplay({
  onSiteSlotsWithoutAssistant,
  remoteSlotsWithoutAssistant,
  onSiteSlotsWithAssistant,
  remoteSlotsWithAssistant,
  rhythmNote,
}: RhythmDisplayProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-2 pl-2">
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">
          {t('rhythm-structured.without-assistant')}
        </span>
        <span className="text-muted-foreground">
          {onSiteSlotsWithoutAssistant ?? '-'}P /{' '}
          {remoteSlotsWithoutAssistant ?? '-'}V
        </span>
      </div>
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">
          {t('rhythm-structured.with-assistant')}
        </span>
        <span className="text-muted-foreground">
          {onSiteSlotsWithAssistant ?? '-'}P / {remoteSlotsWithAssistant ?? '-'}
          V
        </span>
      </div>
      {rhythmNote && (
        <div className="pt-1 text-sm">
          <span className="whitespace-pre-wrap text-muted-foreground">
            {rhythmNote}
          </span>
        </div>
      )}
    </div>
  );
}
